import {ChangeDetectionStrategy, Component, computed, Injectable, input, output} from "@angular/core";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {GruppeLogoKomponent} from "../gruppe-logo/gruppe-logo";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {MatButton} from "@angular/material/button";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GruppeInvitasjonTilGodkjenningModell, GruppeModell, MedlemId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {InvitasjonerDatatjeneste} from "felles-ng2/tjenester/datalager/InvitasjonerDatatjeneste";
import {GruppeGodtaInvitasjonDialogKomponent} from "web-ng2/moduler/gruppe/modale/gruppe-godta-invitasjon-dialog/gruppe-godta-invitasjon-dialog";
import {MatDialog} from "@angular/material/dialog";
import {firstValueFrom} from "rxjs";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";

const debug = initDebugger('GruppeInvitasjonKortKomponent');

/**
 * Viser invitasjon til gruppe.
 */
@Component({
    selector: 'gruppe-invitasjon-kort',
    templateUrl: 'gruppe-invitasjon-kort.html',
    styleUrl: 'gruppe-invitasjon-kort.scss',
    host: { 'data-testid': 'gruppe-invitasjon-kort' },
    imports: [
        MatIcon,
        MatButton,
        TranslateModule,
        FormaterPlainDatePipe,
        ZonedDateTimeSomPlainDatePipe,
        KortKomponent,
        GruppeLogoKomponent,
        KortHandlingerKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeInvitasjonKortKomponent {

    invitasjon = input.required<GruppeInvitasjonTilGodkjenningModell>();
    rolleTittel = computed(()=> erNil(this.invitasjon().rolle)?'':this.invitasjon().rolle.tittel)

    constructor(private avhengigheter: GruppeInvitasjonKortKomponentAvhengigheter, private navigasjon:Navigasjon, private matDialog: MatDialog) {
    }

    async godta() {
        let dialog = GruppeGodtaInvitasjonDialogKomponent.vis(this.matDialog, this.invitasjon());
        const nyGruppe = await firstValueFrom(dialog.afterClosed(), {defaultValue: null});
        // vi vil ikke gå il ny gruppe - de som har flere grupper å godkjenne syns det er veldig irriterende.
        // if (erIkkeNil(nyGruppe)) this.navigasjon.gåTilGruppe(nyGruppe.id);
    }

    async avslaa() {
        await this.avhengigheter.avslåInvitasjon(this.invitasjon().id);
    }

    //private hjelpemetoder

}

@Injectable()
export class GruppeInvitasjonKortKomponentAvhengigheter {

    constructor(private invitasjonerDatatjeneste: InvitasjonerDatatjeneste) {
    }

    avslåInvitasjon(id: MedlemId): Promise<any> {
        return this.invitasjonerDatatjeneste.avslåInvitasjonSomEksisterendeBruker(id);
    }
}
